import { QueryFeature } from '../../../../../../config/queryClient';
import { WhatIfTypeKey } from '../../WhatIfs.meta';
import { EstateTaxesChange } from './EstateTaxesChange/EstateTaxesChange';
import { FORM_SCHEMA as ESTATE_TAXES_CHANGE_FORM_SCHEMA } from './EstateTaxesChange/EstateTaxesChange.meta';
import { EstatePlanningCharitableDonations } from './GeneralChanges/EstatePlanningCharitableDonations/EstatePlanningCharitableDonations';
import { FORM_SCHEMA as ESTATE_PLANNING_CHARITABLE_DONATIONS_FORM_SCHEMA } from './GeneralChanges/EstatePlanningCharitableDonations/EstatePlanningCharitableDonations.meta';
import { EstatePlanningLifeExpectancies } from './GeneralChanges/EstatePlanningLifeExpectancies/EstatePlanningLifeExpectancies';
import { FORM_SCHEMA as ESTATE_PLANNING_LIFE_EXPECTANCIES_FORM_SCHEMA } from './GeneralChanges/EstatePlanningLifeExpectancies/EstatePlanningLifeExpectancies.meta';
import { AnnuityPurchase } from './ProfileChanges/AnnuityPurchase/AnnuityPurchase';
import { FORM_SCHEMA as ANNUITY_PURCHASE_FORM_SCHEMA } from './ProfileChanges/AnnuityPurchase/AnnuityPurchase.meta';
import { BusinessSale } from './ProfileChanges/BusinessSale/BusinessSale';
import {
  DEFAULT_VALUES as SELL_BUSINESS_DEFAULT_VALUES,
  FORM_SCHEMA as SELL_BUSINESS_FORM_SCHEMA,
} from './ProfileChanges/BusinessSale/BusinessSale.meta';
import { IncomeChange } from './ProfileChanges/IncomeChange/IncomeChange';
import { DEFAULT_VALUES as INCOME_CHANGE_DEFAULT_VALUES } from './ProfileChanges/IncomeChange/IncomeChange.meta';
import { MiscellaneousAssetSale } from './ProfileChanges/MiscellaneousAssetSale/MiscellaneousAssetSale';
import {
  DEFAULT_VALUES as MISCELLANEOUS_ASSET_SALE_DEFAULT_VALUES,
  FORM_SCHEMA as MISCELLANEOUS_ASSET_SALE_FORM_SCHEMA,
} from './ProfileChanges/MiscellaneousAssetSale/MiscellaneousAssetSale.meta';
import { RealEstateSale } from './ProfileChanges/RealEstateSale/RealEstateSale';
import {
  DEFAULT_VALUES as SELL_REAL_ESTATE_DEFAULT_VALUES,
  FORM_SCHEMA as SELL_REAL_ESTATE_FORM_SCHEMA,
} from './ProfileChanges/RealEstateSale/RealEstateSale.meta';
import { PensionChange } from './ProfileChanges/PensionChange/PensionChange';
import { FORM_SCHEMA as PENSION_CHANGE_FORM_SCHEMA } from './ProfileChanges/PensionChange/PensionChange.meta';
import { Windfall } from './ProfileChanges/Windfall/Windfall';
import { FORM_SCHEMA as WINDFALL_FORM_SCHEMA } from './ProfileChanges/Windfall/Windfall.meta';
import { LivingExpensesChange } from './ProfileChanges/LivingExpensesChange/LivingExpensesChange';
import { FORM_SCHEMA as LIVING_EXPENSES_CHANGE_FORM_SCHEMA } from './ProfileChanges/LivingExpensesChange/LivingExpensesChange.meta';

export const getWhatIfsTypesMetadata = whatIfType => ({
  [WhatIfTypeKey.BusinessSale]: {
    Component: BusinessSale,
    defaultValues: SELL_BUSINESS_DEFAULT_VALUES,
    formSchema: SELL_BUSINESS_FORM_SCHEMA,
  },
  [WhatIfTypeKey.RealEstateSale]: {
    Component: RealEstateSale,
    defaultValues: SELL_REAL_ESTATE_DEFAULT_VALUES,
    formSchema: SELL_REAL_ESTATE_FORM_SCHEMA,
  },
  [WhatIfTypeKey.MiscellaneousAssetSale]: {
    Component: MiscellaneousAssetSale,
    defaultValues: MISCELLANEOUS_ASSET_SALE_DEFAULT_VALUES,
    formSchema: MISCELLANEOUS_ASSET_SALE_FORM_SCHEMA,
  },
  [WhatIfTypeKey.IncomeChanges]: {
    Component: IncomeChange,
    defaultValues:
      whatIfType.WhatIf.Incomes && whatIfType.WhatIf.Incomes.length > 0
        ? whatIfType.WhatIf
        : INCOME_CHANGE_DEFAULT_VALUES,
    formSchema: null,
  },
  [WhatIfTypeKey.EstateTaxesChange]: {
    Component: EstateTaxesChange,
    defaultValues: whatIfType.WhatIf,
    formSchema: ESTATE_TAXES_CHANGE_FORM_SCHEMA,
    queryFeature: QueryFeature.EstatePlanning,
  },

  [WhatIfTypeKey.EstatePlanningLifeExpectancies]: {
    Component: EstatePlanningLifeExpectancies,
    defaultValues: whatIfType.WhatIf,
    formSchema: ESTATE_PLANNING_LIFE_EXPECTANCIES_FORM_SCHEMA,
    queryFeature: QueryFeature.EstatePlanning,
  },

  [WhatIfTypeKey.EstatePlanningCharitableDonations]: {
    Component: EstatePlanningCharitableDonations,
    defaultValues: whatIfType.WhatIf,
    formSchema: ESTATE_PLANNING_CHARITABLE_DONATIONS_FORM_SCHEMA,
    queryFeature: QueryFeature.EstatePlanning,
  },

  [WhatIfTypeKey.AnnuityPurchase]: {
    Component: AnnuityPurchase,
    defaultValues: whatIfType.WhatIf,
    formSchema: ANNUITY_PURCHASE_FORM_SCHEMA,
  },

  [WhatIfTypeKey.Windfall]: {
    Component: Windfall,
    defaultValues: whatIfType.WhatIf,
    formSchema: WINDFALL_FORM_SCHEMA,
  },

  [WhatIfTypeKey.PensionChange]: {
    Component: PensionChange,
    defaultValues: whatIfType.WhatIf,
    formSchema: PENSION_CHANGE_FORM_SCHEMA,
  },

  [WhatIfTypeKey.LivingExpensesChange]: {
    Component: LivingExpensesChange,
    defaultValues: whatIfType.WhatIf,
    formSchema: LIVING_EXPENSES_CHANGE_FORM_SCHEMA,
  },
});
